<template>
    <v-container>
        <v-alert type="success" :value="success" transition="slide-x-transition">
            Objednávka bola úspešne potvrdená, jej stav môžeš skontrolovať v sekcií <a href="userDashboard">"Objednávky"</a>.
        </v-alert>
        <v-row justify="center">
            <h2>
                <span class="pa-1">Nové objednávky</span>
            </h2>
        </v-row>
        <v-divider/>
        <v-container v-if="!noOrders">
          <v-container  v-for="order in orders" :key="order.code">
            
            <v-card elevation="10" :id="''+order.id">
                <v-row justify="center"><v-col cols="12"><cleaner-order  :order="order"></cleaner-order></v-col></v-row>
                <v-row class="justify-center">
                    <v-col class="text-center" cols="12">
                        <v-btn color="success"  @click="approveOrder(order.id)">
                            Potvrdiť objednávku
                        </v-btn>
                    </v-col>
                </v-row>           
            </v-card>
            <v-spacer></v-spacer>
          </v-container>
        </v-container>
        <v-container v-else>
            <span class="pa-1">Nemáte žiadne nové objednávky</span>
        </v-container>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import store from "../store/store";
    import CleanerOrder from './orders/CleanerOrder.vue';

    export default{
        components: { CleanerOrder },
        name: "CleanerOrders",
        data: () => ({
            success: false,
            loading: false,
            userId: 1,
            show: false,
            orders:[],
            noOrders : false
        }),
        methods:{
            fetchAllData(){
                axios.get(store.state.url.concat('getNewOrders.php'), {
                    params: {
                        user: localStorage.getItem('loggedUserId')
                    }
                }).then((response) => {
                    if(response.data.result){
                        if(response.data.result == 'noOrders') {
                            this.noOrders = true;
                            this.$emit('noOrders');
                        }
                    }else{
                        this.noOrders = false;
                        this.orders = response.data
                        /*response.data.forEach(element => {
                            this.findOrder(element.code);
                        });*/
                        this.$emit('orders');
                    }
                })
            },
            getEuroDate(date) {
                var myDate = new Date(date);
                return (
                    ("0" + myDate.getDate()).slice(-2) + "." + ("0" + (myDate.getMonth() + 1)).slice(-2)  + "." + myDate.getFullYear()
                );
            },
            alertOrderApproved() {
                this.success = true;
                setTimeout(() => {
                    this.success = false;
                }, 3500)
            },
            approveOrder(orderId){
                    this.error = '';
                    const params = new URLSearchParams();
                    params.append('user', localStorage.getItem('loggedUserId'));
                    params.append('orderId', orderId);
                    axios({
                        method: 'post',
                        url: store.state.url.concat('approveOrder.php'),
                        data: params
                    }).then((response) => {
                        if(response.data.result == 'ok') {
                            this.alertOrderApproved()
                            document.getElementById('' + orderId).remove();
                            this.$router.push({name: 'newOrders'}).catch(()=>{});
                        }else{
                            this.error = response.data.error;
                        }
                    });
            },
            findOrder(codeOfOrder){
                const params = new URLSearchParams();
                params.append('orderCode', codeOfOrder);
                axios({
                method: 'post',
                url: store.state.url.concat('findOrderByCode.php'),
                data: params
                }).then((response) => {
                    if(response.data.result == 'ok') {
                        this.orders.unshift(response.data);
                    }
                });
            }
        },
        created(){
            this.fetchAllData();
        }
    }
</script>
<style>
    .no-border {
    border: none !important;
    }
</style>